import React, { Component } from 'react';
import './styles.css';
import YouTubePlayer from '../../atoms/YouTubePlayer';
import PlayButton from '../../atoms/PlayButton';
import { HTMLVideoPlayer } from '../../atoms';
/**
 * AccordionItem
 *
 * @typedef {Object} Props
 * @prop {string} videoId
 * @prop {'youtube'|'html'} type
 * @prop {Boolean} isToggled
 *
 * @augments {Component<Props>}
 */
export default class VideoBox extends Component {
	state = { show: false };

	handleClick = () => {
		this.setState({ show: true });
	};

	render () {
		const { videoId, isToggled, type } = this.props;
		return (
			<div className='videoBox'>
				{
					type === 'html' &&
					<HTMLVideoPlayer
						className='video-wrap'
						videoPath={videoId}
						isToggled={isToggled}
						controls
					/>
				}
				{type === 'youtube' && (this.state.show ? (
					<YouTubePlayer
						className='video-wrap'
						videoId={videoId}
						isToggled={isToggled}
					/>
				) : (
					<div>
						<picture>
							<img
								src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
								className='videoBoxImg'
								alt={videoId}
							/>
						</picture>
						<span className='videoButton'>
							<PlayButton onClick={this.handleClick} />
						</span>
					</div>
				))}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/molecules/VideoBox/VideoBox.js